import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'strategySelect',
    'underPriceField',
    'trendingField',
    'strategyHint',
    'sliderModeSelect',
    'stepIntervalField',
    'marqueeDurationField',
    'arrowsField'
  ]

  connect () {
    this.syncStrategyFields()
    this.syncSliderFields()
  }

  strategyChanged () {
    this.syncStrategyFields()
  }

  sliderModeChanged () {
    this.syncSliderFields()
  }

  syncStrategyFields () {
    if (!this.hasStrategySelectTarget) return

    const strategy = this.strategySelectTarget.value || ''
    if (this.hasUnderPriceFieldTarget) {
      this.underPriceFieldTarget.classList.toggle('hidden', strategy !== 'under_price')
    }
    if (this.hasTrendingFieldTarget) {
      this.trendingFieldTarget.classList.toggle('hidden', strategy !== 'trending')
    }
    if (this.hasStrategyHintTarget) {
      const hints = {
        pinned_only: 'Only pinned products appear. Pin products after creating the section.',
        under_price: 'Shows in-stock products at or below your PKR ceiling.',
        daily_deals: 'Prioritises products with the strongest active discounts.',
        popular_nearby: 'Uses the shopper city selector on the homepage.',
        trending: 'Ranks by recent marketplace sales and wishlists.'
      }
      this.strategyHintTarget.textContent = hints[strategy] || 'Pinned products appear first; the strategy fills remaining slots.'
    }
  }

  syncSliderFields () {
    const mode = this.sliderModeSelectTarget?.value || ''
    if (this.hasStepIntervalFieldTarget) {
      this.stepIntervalFieldTarget.classList.toggle('hidden', mode !== 'autoplay')
    }
    if (this.hasMarqueeDurationFieldTarget) {
      this.marqueeDurationFieldTarget.classList.toggle('hidden', mode !== 'marquee')
    }
    if (this.hasArrowsFieldTarget) {
      this.arrowsFieldTarget.classList.toggle('hidden', mode === 'marquee' || mode === 'off')
    }
  }
}
